import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import Honeybadger from 'honeybadger-js'
import { useLDClient } from 'launchdarkly-react-client-sdk'

import useLDFlags from 'utils/hooks/useLDFlags'

const FlagsContext = React.createContext({
  flags: {},
  loading: true,
})

export function FlagsProvider({ children }) {
  const ldClient = useLDClient()
  const { flags, loading } = useLDFlags()

  useEffect(() => {
    if (!ldClient) return

    const handleError = error => {
      Honeybadger.notify(error)
    }

    ldClient.on('error', handleError)
    ldClient.on('failed', handleError)

    return () => {
      ldClient.off('error', handleError)
      ldClient.off('failed', handleError)
    }
  }, [ldClient])

  return (
    <FlagsContext.Provider value={{ flags, loading }}>
      {children}
    </FlagsContext.Provider>
  )
}

FlagsProvider.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
}

export const useWithFlags = () => React.useContext(FlagsContext)

export const Flags = FlagsContext
